module.exports = __webpack_public_path__ + "static/media/beep-08b.b76b0645.mp3";